export default "__VITE_ASSET__aQiOg9v3__"